<template>
    <div class="upload-material">
        <div class="upload-material__content">
            <el-form :model="form" :rules="rules" ref="form" name="uploadMaterial" key="uploadMaterial"  class="upload-material__form">
                <div class="upload-material__form-item">
                    <div class="upload-material__title">
                        <span>素材简介</span>
                        <span class="description">（填写格式：素材名称+源文件格式+你的微信号，素材审核通过后，数字像素官方小编(微信号：shuzixs01)将与你联系，期待与你合作）</span>
                    </div>
                    <el-form-item prop="content">
                        <el-input
                            type="textarea"
                            :maxlength="200"
                            show-word-limit
                            placeholder="例如：素材名称：大屏底座素材模型；源文件格式：ai、psd；微信号：shuaixs01"
                            v-model="form.content"
                            :autosize="{ minRows: 4, maxRows: 8 }"
                        />
                    </el-form-item>
                </div>
                <div class="upload-material__form-item">
                    <div class="upload-material__title">
                        <span>上传图片</span>
                        <span class="description">（提供素材样图或截图，最多上传10张图片）</span>
                    </div>
                    <div class="image-uploader__wrapper image__wrapper">
                        <el-upload
                            ref="pictureUploader"
                            action="/TobDesign/api/file/uploadLocal?type=work" 
                            list-type="picture-card"
                            multiple
                            :file-list="fileList"
                            :before-upload="beforePictureUpload"
                            :on-preview="handlePicturePreview"
                            :on-change="handlePictureChange"
                            :on-remove="handlPictureRemove"
                            accept="image/jpeg,image/jpg,image/png,image/gif"
                        >
                            <svg-icon
                                icon-class="upload"
                                class-name="icon-upload"
                            ></svg-icon>
                        </el-upload>
                    </div>
                </div>
                <div class="form-btns">
                    <el-button type="primary" class="form-button" :loading="submitLoading" @click="handleSubmit">提交审核</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import AliOSS from 'ali-oss';
import Sortable from 'sortablejs';
import { uploadMaterial, editWork } from '@/api/material';
import { getOSSConfig } from '@/api/common';
// import PreviewWork from './PreviewWork';
// import aliOSS from '@/utils/aliOSS';
export default {
    name: 'UploadMaterial',
    components: {
        // PreviewWork
    },
    inject: ['interceptLeave'],
    data: () => ({
        mode: 'add',
        selectOptions: {
            flId: [],
            bqId: [],
            hyId: []
        },
        isUploading: false,
        videoList: [],
        fileList: [],
        fileListLen: 0,
        detailId: null,
        form: {
            title: '',
            flId: null,
            // industryId: null,
            labelId: 36,
            content: '',
            logo: null,
            urlList: []
        },
        rules: {
            content: [
                { required: true, message: '请输入素材简介', trigger: 'blur' },
            ],
        },
        dialogVisible: false,
        submitLoading: false,
        submitAction: false,
        isUpdate: false,
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    beforeRouteLeave(to, from, next) {
        if (!this.submitAction && !this.isEmptyForm()) {
            setTimeout(() => {
                this.$confirm('当前页面已有内容，是否确认离开此页面？')
                    .then(() => {
                        next(true);
                    })
                    .catch(() => {
                        next(false);
                    });
            }, 200)
        } else {
            next();
        }
    },
    created() {
        window.addEventListener('beforeunload', this.listenInterceptLeave);
    },
    mounted() {
        this.cardDrop();
        this.getOptions();
        const { id } = this.$route.query;
        if (id) {
            this.mode = 'edit';
            this.detailId = id;
            this.getWorkDetail(id);
        }
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.listenInterceptLeave);
    },
    methods: {
        listenInterceptLeave(e) {
            this.interceptLeave(e, !this.submitAction && !this.isEmptyForm());
        },
        isEmptyForm() {
            if (
                this.form.title === '' &&
                this.form.content === '' &&
                this.form.logo === null &&
                this.form.urlList.length === 0 && !this.fileListLen &&
                !this.form.video && this.videoList.length === 0
            ) {
                return true;
            }
            return false;
        },
        // 获取作品详情
        getWorkDetail(id) {
            getUserZuoPinDetail({ zId: id, userId: this.userInfo.id }).then(({ code, data }) => {
                if (code === 0) {
                    this.form.title = data.title;
                    this.form.content = data.content;
                    this.form.logo = data.logo;
                    this.form.flId = data.flId;
                    this.form.labelId = data.labelId;
                    // this.form.industryId = data.industryId;
                    this.form.urlList = data.pictureList.map(({ address }) => {
                        return address;
                    });
                    this.fileList = data.pictureList.map(({ address }) => {
                        return {
                            name: '图片',
                            url: address
                        };
                    });
                    this.videoList = data.video.split(',').map((url) => {
                        return {
                            name: decodeURI(url.split('/').pop()),
                            url
                        };
                    });
                    this.handleChangeIcon();
                }
            });
        },
        getOptions() {
            // 获取作品分类
            getWorkTabs({
                type: 1
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.selectOptions.flId = [
                    ...options
                ];
            });
            // 获取作品标签
            getWorkTabs({
                type: 3
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.selectOptions.bqId = [
                    ...options
                ];
            });
            // 获取作品行业
            getWorkTabs({
                type: 2
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.selectOptions.hyId = [
                    ...options
                ];
            });
        },
        // 上传封面
        handleCoverSuccess(res) {
            this.form.logo = res.data;
        },
        beforeCoverUpload(file) {
            const isIMG = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type);
            const isLt500KB = file.size / 1024 < 500;

            if (!isIMG) {
                this.$message.error('请上传图片');
                return false;
            }

            if (!isLt500KB) {
                this.$message.error('上传图片大小不能超过 500KB!');
            }
            return isIMG && isLt500KB;
        },
        cardDrop() {
            const wrapper = document.querySelector('.image__wrapper .el-upload-list');
            Sortable.create(wrapper, {
                draggable: '.el-upload-list__item', // 允许拖拽的项目类名
                delay: 0,
                onEnd: evt => {
                    const oldItem = this.fileList[evt.oldIndex];
                    this.fileList.splice(evt.oldIndex, 1);
                    this.fileList.splice(evt.newIndex, 0, oldItem);
                }
            });
        },
        handleChangeIcon(file, fileList) {
            file && this.handleVideoChange(file, fileList);
            this.$nextTick(() => {
                const icons = this.$refs.videoUploader.$el && this.$refs.videoUploader.$el.getElementsByClassName('el-icon-document');

                icons && Array.from(icons).forEach((icon) => {
                    icon.setAttribute("class", 'el-icon-video-play');
                });
            });
        } ,
        // 上传视频前校验
        beforeVideoUpload(file) {
            const isVideo = file.type.indexOf('video') > -1;
            const isLt500M = file.size < 500 * 1024 * 1024;
            if (!isVideo) {
                this.$message.error('请上传视频');
                return false;
            }
            if (!isLt500M) {
                this.$message.error('视频大小不能超过500M');
                return false;
            }
            return isVideo && isLt500M;
        },
        handleVideoChange(file, fileList) {
            this.videoList = fileList;
        },
        // 删除视频
        async handlVideoRemove(file, fileList) {
            this.videoList = fileList;
            let config = await getOSSConfig();
            var client = new AliOSS({
                region: 'oss-cn-chengdu',
                accessKeyId: config.data.accessid,
                accessKeySecret: 'fEenefEpkSzxjT3wsIidFDHRHdslq9',
                bucket: 'shuzixs1',
                policy: config.data.policy,
                signature: config.data.signature,
                secure: true
            });
            client.delete(file.response ? file.response.name : new URL(file.url).pathname);
        },
        // 上传视频
        async uploadRequest (option) {
            try {
                this.isUploading = true;
                let file = option.file;
                let config = await getOSSConfig();
                var client = new AliOSS({
                    region: 'oss-cn-chengdu',
                    accessKeyId: config.data.accessid,
                    accessKeySecret: 'fEenefEpkSzxjT3wsIidFDHRHdslq9',
                    bucket: 'shuzixs1',
                    policy: config.data.policy,
                    signature: config.data.signature,
                    secure: true
                });
                // let client = aliOSS(config.data);
                // 上传文件
                const res = await client.multipartUpload(`${Math.floor(Math.random()*(9999-1000))+9999}/video/` + encodeURI(file.name), file, {
                    progress: async function (p) {
                        let e = {}
                        e.percent = p * 100
                        option.onProgress(e)
                    }
                });
                if (res.res.statusCode === 200) {
                    return res;
                } else {
                    option.onError('上传失败')
                }
            } catch (error) {
                option.onError('上传失败')
                this.$error(error.message)
            } finally {
                this.isUploading = false;
            }
        },
        // 上传作品
        beforePictureUpload(file) {
            const isIMG = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type);
            const isLt10M = file.size < 10 * 1024 * 1024;
            const isLt80 = this.fileListLen <= 10;
            if (!isIMG) {
                this.$message.error('请上传图片');
                return false;
            }
            if (!isLt10M) {
                this.$message.error('图片大小不能超过10M');
                return false;
            }
            if (!isLt80) {
                this.$message.error('图片不能超10张');
                return false;
            }
            return isLt10M && isLt80 && isIMG;
        },
        handlePictureChange(file, fileList) {
            this.fileList = fileList;
            this.fileListLen = fileList.length;
        },
        handlPictureRemove(file, fileList) {
            this.fileList = fileList;
            this.fileListLen = fileList.length;
        },
        handlePicturePreview(file) {
            const url = file.url || file.thumbUrl;
            const aTag = document.createElement('a');
            let href = url;
            aTag.href = href;
            aTag.target = '_blank';
            aTag.click();
            return;
        },
        getUrlList() {
            this.form.urlList = this.$refs.pictureUploader.uploadFiles.map(({ url, response }) => {
                return  (response && response.data[0]) || url;
            });
        },
        // 预览作品
        handlePreview() {
            this.getUrlList();
            this.dialogVisible = true;
        },
        /**
         * 发布作品
         * @param status 1正式 2草稿
         */
        handleSubmit(status) {
            if (this.isUploading) {
                this.$message.warning('正在上传视频，请稍后发布');
                return;
            }
            this.getUrlList();
            this.$refs.form.validate(valid => {
                if (valid) {
                    console.log(this.form)
                    if (this.form.urlList.length === 0 && !this.form.video) {
                        this.$message.error('请上传图片');
                        return;
                    }
                    const params = {
                        status:0,
                        imageUrl:this.form.urlList,
                        userId: this.userInfo.id,
                        userName: this.userInfo.name,
                        content: this.form.content
                    };
                    this.submitLoading = true;
                    if (this.mode === 'edit') {
                        params.id = this.detailId;
                        editWork(params).then(({ code }) => {
                            if (code === 0) {
                                this.$message.success(`${status === 1 ? '发布' : '提交'}成功`);
                                this.submitAction = true;
                                this.$router.push({
                                    name: 'User' ,
                                    query: {
                                        type: 8
                                    }
                                });
                            }
                        }).finally(() => {
                            this.submitLoading = false;
                        });
                    } else {
                        uploadMaterial(params).then(({ code }) => {
                            if (code === 0) {
                                this.$message.success(`${status === 1 ? '发布' : '提交'}成功`);
                                this.submitAction = true;
                                this.$router.push({
                                    name: 'User' ,
                                    query: {
                                        type: 8
                                    }
                                });
                            }
                        }).finally(() => {
                            this.submitLoading = false;
                        });
                    }
                }
            });
        },
    }
};
</script>

<style lang="scss">
.upload-material .image-uploader__wrapper {
    .el-upload--picture-card {
        width: 240px;
        height: 160px;
        line-height: 160px;
        border: 1px solid #e0e4f7;
        transition: border-color .5s;
        background: rgba(224, 228, 247, 0.37);

        &:hover {
            border-color: #C0C4CC;
        }
    }
    .el-upload-list--picture-card .el-upload-list__item {
        width: 240px;
        height: 160px;

        .el-icon-close-tip {
            display: none !important;
        }
    }
    .el-upload-list__item .el-progress-bar {
        margin-top: 10px;
    }
}
.video__wrapper {
    .el-upload-list {
        &__item {
            [class^='el-icon-'] {
                font-size: 20px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .upload-material .image-uploader__wrapper {
        .el-upload--picture-card {
            width: 180px;
            height: 120px;
            line-height: 120px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width: 180px;
            height: 120px;
        }
    }
    .el-progress .el-progress-circle {
        margin: 0 auto;
        width: 100px!important;
        height: 100px!important;
    }
}
</style>

<style lang="scss" scoped>
.video__wrapper {
    width: 60%;
}
.upload-material {
    padding-top: 20px;
    display: flex;

    &__title {
        display: flex;
        align-items: center;
        height: 40px;
        line-height: 40px;
        @include font(rgba(38, 42, 63, 1), 14px, 600);

        .description {
            margin-left: 5px;
            @include font(#919191, 12px, 400);
        }
        &__input {
            & /deep/ .el-input__inner {
                padding-right: 50px;
            }
        }
    }

    &__content {
        flex: 1;
    }

    &__form {
        &-item {
            &:not(:first-child) {
                margin-top: 10px;
            }
        }
        .image-uploader__wrapper {
            overflow: hidden;
        }

        .form-btns {
            display: flex;
            margin-top: 30px;
        }
        .form-button {
            width: 120px;
            height: 40px;
            margin-right: 20px;
        }
        .icon-upload {
            font-size: 24px;
            color: rgba(0, 172, 188, 1);
        }
    }
}

// 小屏
@include mq($small) {
    .upload-material {
        padding-top: 15px;

        &__title {
            height: 30px;
            line-height: 30px;
        }

        .aside {
            width: 225px;
            margin-right: 18px;

            .cover-uploader__wrapper {
                width: 225px;
                height: 150px;
            }
            .cover-image {
                width: 225px;
                height: 150px;
            }

            .icon-upload {
                font-size: 18px;
            }
        }

        &__form {
            .icon-upload {
                font-size: 18px;
            }
        }
    }
}
</style>
